<h2>Seja bem-vindo ao PremoCenter!</h2>
<p>Como é seu primeiro acesso a nossa plataforma é necessário definir uma nova senha.</p>
<form [formGroup]="form" (ngSubmit)="atualizar()">
    <div class="row">
        <div class="col-10">
            <input #input type="password" formControlName="vc_senha" class="form-control" placeholder="Nova senha">
            <ng-container *ngIf="form.controls.vc_senha.touched" >
                <p class="msg-erro" *ngIf="form.controls.vc_senha.errors?.required">Campo obrigatório *</p>
                <p class="msg-erro" *ngIf="form.controls.vc_senha.errors?.minlength">Minimo 6 caracteres *</p>
            </ng-container>
        </div>
        <div class="col-2">
            <mat-icon (click)="changeInput(input)" *ngIf="password" class="material-icons-outlined visibilidade">
                visibility
            </mat-icon>
            <mat-icon (click)="changeInput(input)" *ngIf="text" class="material-icons-outlined visibilidade">
                visibility_off
            </mat-icon>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-1">
        <button class="btn-sucesso" type="submit" [disabled]="!form.valid">Confirmar</button>
    </div>
</form>